export const SEN_STATUSES = {
    K: 'K',
    KS: 'KS',
    KI: 'KI',
    N: 'N',
    E: 'E',
}
